export default __webpack_public_path__ + "media/images/backgrounds/white-strip-fee72deeb365e1a4969ccf1afbacf275.svg";